// Force the css import to be a separate file
// import {default as CSSLoader} from 'css';
// CSSLoader.separateCSS = true;
// CSSLoader.buildCSS    = false;

import '@nuskin/ns-util';
import '@nuskin/ns-account';
import '@nuskin/ns-common-angularjs';
import '@nuskin/ns-shop';
import '@nuskin/ns-app-elements';
import '@nuskin/ns-shop-elements';

import 'babel-polyfill';

import './stylesheets/checkout.scss';

import './app.js';
import './controllers/orderSummary.js';
import './controllers/orderConfirmation.js';
import './controllers/adrShipWhen.js';
import './controllers/fatalError.js';
import './controllers/downtime.js';
import './controllers/externalPayment.js';
import './domain/sections';

import Vue from 'vue';
import Vuetify from 'vuetify';
import vueCustomElement from 'vue-custom-element';
window.Vue = Vue;
Vue.use(Vuetify);
Vue.use(vueCustomElement);

import {NsHeader, NsFooter} from '@nuskin/app-components';
import {NsAddressSelector, NsPaymentSelector} from '@nuskin/app-elements';
// import {VApp} from 'vuetify/lib';
// Vue.customElement('v-app', VApp);
Vue.customElement('ns-address-selector', NsAddressSelector);
Vue.customElement('ns-payment-selector', NsPaymentSelector);
Vue.customElement('ns-header', NsHeader);
Vue.customElement('ns-footer', NsFooter);

export {default as configSdk} from '@nuskin/configuration-sdk';
export {RunConfigService, UrlService, ShoppingContext, init, events} from '@nuskin/ns-util';
export {eidLogin, Receiver} from '@nuskin/ns-shop';
